import { z } from "zod";
import i18next from "i18next";

/**
 * Maps Zod validation errors to localized, user-friendly strings.
 */
export const zodErrorMap: z.core.$ZodErrorMap = (issue) => {
  const t = i18next.t.bind(i18next);

  switch (issue.code) {
    case "invalid_type":
      return t("zod_errors.required");

    case "too_small":
      if (issue.origin === "string") {
        return t("zod_errors.required");
      }
      if (issue.origin === "array") {
        return t("zod_errors.select_at_least_one");
      }
      if (issue.origin === "number" || issue.origin === "bigint" || issue.origin === "int") {
        return t("zod_errors.invalid_value");
      }
      break;

    case "invalid_format":
      if (issue.format === "date" || issue.format === "datetime" || issue.format === "time") {
        return t("zod_errors.invalid_date");
      }
      if (issue.format === "email") {
        return t("zod_errors.invalid_email");
      }
      break;

    case "invalid_value":
      return t("zod_errors.invalid_value");
  }

  // Returning undefined yields control to the next error map in the chain.
  return undefined;
};
